import styled from 'styled-components';

export const Input = styled.input`
  width: 100%;
  border-radius: 6px;
  padding: 12.7px 15px;
  border: 1px solid rgba(41, 45, 50, 0.25);
  :focus {
    outline: none !important;
    border: 2px solid #466afb;
    padding: 11.9px 14px;
  }
`;
